/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('extrasNews.infinite-scroll', function (el) {
        var hasNext = document.querySelector('.scroller-status a.stepper.next');
        if (!hasNext) {
            return;
        }
        el.classList.add('hasMore');
        MoyaLoader.js('https://unpkg.com/infinite-scroll@4/dist/infinite-scroll.pkgd.min.js').then(function () {
            new InfiniteScroll(el, {
                path: 'a.stepper.next',
                append: '.news__card',
                status: '.scroller-status',
                button: '.load__more',
                loadOnScroll: false,
            });
        });
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
